import { render, staticRenderFns } from "./ewmInfo.vue?vue&type=template&id=20c5d70b&scoped=true&"
import script from "./ewmInfo.vue?vue&type=script&lang=js&"
export * from "./ewmInfo.vue?vue&type=script&lang=js&"
import style0 from "./ewmInfo.vue?vue&type=style&index=0&id=20c5d70b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c5d70b",
  null
  
)

export default component.exports